module.exports = __webpack_public_path__ + "img/icon-gift-card.3a3507ad.svg";